import React, { useContext } from 'react';

import { SkeletonLoader, TabletScreen, MobileScreen, StaticContext } from '@sm/webassets';
import { getClientEnvironmentDetails } from '@sm/utils';

const CategorySectionSkeleton = props => {
  const { userAgent } = useContext(StaticContext);
  const { isMobile } = getClientEnvironmentDetails(userAgent);
  return (
    <>
      <TabletScreen defaultMatches={!isMobile}>
        <SkeletonLoader width={776} height={520} {...props}>
          <rect x="0" y="0" ry="0" width="236" height="258" />
          <rect x="260" y="0" ry="0" width="236" height="258" />
          <rect x="540" y="0" ry="0" width="236" height="258" />
          <rect x="0" y="270" ry="0" width="236" height="258" />
          <rect x="260" y="270" ry="0" width="236" height="258" />
          <rect x="540" y="270" ry="0" width="236" height="258" />
        </SkeletonLoader>
      </TabletScreen>

      <MobileScreen defaultMatches={isMobile}>
        <SkeletonLoader height={140} width={320} className="wds-display--md-none" {...props}>
          <rect x="125" y="20" rx="0" ry="0" width="80" height="80" />
          <rect x="110" y="110" rx="0" ry="0" width="110" height="10" />
          <rect x="100" y="130" rx="0" ry="0" width="130" height="10" />
        </SkeletonLoader>
      </MobileScreen>
    </>
  );
};

export default CategorySectionSkeleton;
